<template>
    <ConfirmDialog />
</template>

<script>
export default {
    name: "ConfirmComponent",
};
</script>
